export default "__VITE_ASSET__b618a876__"